import {Injectable} from '@angular/core';
import {MedicalRecordPainModel} from '../../api/model/medicalRecordPain.model';
import {MedicalPainRepository} from './ngxr/medicalPain.repository';
import {MedicalPainDataServiceAdapter} from './ngxr/medicalPainDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class MedicalPainFindOneByIdService extends
    AbstractFindOneByIdService<MedicalRecordPainModel, MedicalRecordPainModel> {

    constructor(private service: MedicalPainRepository,
                dataService: MedicalPainDataServiceAdapter) {
        super(service, dataService);
    }
}
